module.exports = "/_next/static/images/404-f775fa85b62935fa8292e882e72f207e.png";